import axios from "axios";

export const GET_SERVICES = "GET_SERVICES";
export const ADD_SERVICE = "ADD_SERVICE";

export const getServices = () => async (dispatch) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/service`,
      { withCredentials: true }
    );
    dispatch({ type: GET_SERVICES, payload: res.data });
  } catch (error) {
    console.error(error);
  }
};

// Crée un service persisté (réservé aux admins côté serveur) et renvoie le service créé
export const createService = (label, icon = null) => async (dispatch) => {
  const res = await axios({
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/api/service`,
    withCredentials: true,
    data: { label, value: label, icon },
  });
  dispatch({ type: ADD_SERVICE, payload: res.data });
  return res.data;
};
